import "./SpecTable.css";
import { isInStock, lowStockCount } from "../../utils/stock";

// Matches ProductInfo.jsx / ProductCard.jsx, which each define their own copy
// of this threshold — kept in sync manually, same convention as those.

const SpecTable = ({ product }) => {
  const specRows = [
    product.sku                && { label: "SKU",                value: product.sku },
    product.product_model      && { label: "Model",              value: product.product_model },
    product.production_country && { label: "Production Country", value: product.production_country },
    product.weight_kg          && { label: "Weight (kg)",        value: `${product.weight_kg} kg` },
    product.main_material      && { label: "Main Material",      value: product.main_material },
    product.manufacturer       && { label: "The Manufacturer",   value: product.manufacturer },
    product.care_label         && { label: "Care Label",         value: product.care_label },
    product.warranty_type      && { label: "Warranty Type",      value: product.warranty_type },
    product.warranty_address   && { label: "Warranty Address",   value: product.warranty_address },
    product.category           && { label: "Category",           value: product.category },
    product.subcategory        && { label: "Subcategory",        value: product.subcategory },
    (product.availability !== undefined || product.stock_count !== undefined) && {
      label: "Availability",
      value: isInStock(product)
        ? lowStockCount(product) != null
          ? `Only ${lowStockCount(product)} left`
          : "In Stock"
        : "Out of Stock",
      // Colour follows the same green/amber/red vocabulary as the buying
      // panel's stock line (.pi-stock-* in ProductInfo.css), so availability
      // reads identically wherever it appears on the page.
      valueClass: isInStock(product)
        ? lowStockCount(product) != null
          ? "spec-stock-low"
          : "spec-stock-ok"
        : "spec-stock-out",
    },
    product.is_preorder && { label: "Type", value: "Pre-Order" },
  ].filter(Boolean);

  const keyFeatures = product.key_features
    ? product.key_features.split("\n").map((l) => l.trim()).filter(Boolean)
    : [];

  const boxItems = product.whats_in_the_box
    ? product.whats_in_the_box.split("\n").map((l) => l.trim()).filter(Boolean)
    : [];

  const hasContent = specRows.length > 0 || keyFeatures.length > 0 || boxItems.length > 0;
  if (!hasContent) return null;

  return (
    <div className="spec-wrap">
      {/* Key Features */}
      {keyFeatures.length > 0 && (
        <div className="spec-table">
          <p className="spec-heading">Key Features</p>
          <ul className="spec-features">
            {keyFeatures.map((f, i) => (
              <li key={i} className="spec-feature-item">{f}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Specifications */}
      {specRows.length > 0 && (
        <div className="spec-table" role="table" aria-label="Product specifications">
          <p className="spec-heading" role="rowgroup">Specifications</p>
          <div role="rowgroup">
            {specRows.map(({ label, value, valueClass }) => (
              <div key={label} className="spec-row" role="row">
                <span className="spec-label" role="rowheader">{label}</span>
                <span className={`spec-value${valueClass ? ` ${valueClass}` : ""}`} role="cell">{value}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* What's in the Box */}
      {boxItems.length > 0 && (
        <div className="spec-table">
          <p className="spec-heading">What's in the Box</p>
          <ul className="spec-box-list">
            {boxItems.map((item, i) => (
              <li key={i} className="spec-box-item">{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SpecTable;
